import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { SortSelect } from '../sort-select';
import { ProductCard } from '../../../common/product-card';
import { Spinner } from '../../../common/spinner';
import { SearchStore } from '../../../stores/SearchStore';
import { FiltersMobile } from '../filters-mobile';
import iconSystem from '../product-list/icon-system.svg';
import iconFilter from '../../../assets/images/icon-filter.svg';
import styles from './ProductMobileList.css';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

class ProductMobileList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFilterOpen: false,
    };
    this._toggleIsFiltersOpen = this._toggleIsFiltersOpen.bind(this);
    this._onFilterElementClick = this._onFilterElementClick.bind(this);
  }

  _toggleIsFiltersOpen() {
    this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }));
  }

  _onFilterElementClick(event) {
    event.preventDefault();
    this._toggleIsFiltersOpen();
  }

  render() {
    return (
      <div className={[this.props.className, styles.container].join(' ')}>
        <h3 className={styles.subtitle}>
          Resultados de Búsqueda
        </h3>
        <h1 className={styles.title}>
          {SearchStore.query || ''}
        </h1>
        {
          SearchStore.error &&
          <div className={styles.message}>
            <img src={iconSystem} alt="" />
            <p>
              <b>
                Error interno
              </b>
            </p>
            <p>
              Estamos enfrentando algunos problemas en este momento, por favor
              inténtalo nuevamente.
            </p>
          </div>
        }
        {
          !SearchStore.filteredProducts &&
          !SearchStore.error &&
          <div>
            <Spinner />
          </div>
        }
        {
          !!SearchStore.filteredProducts &&
          !!SearchStore.filteredProducts.length &&
          <div>
            <div className={styles.sortSection}>
              <p className={styles.genericMessage}>
                {SearchStore.filteredProducts.length} resultado{SearchStore.filteredProducts.length === 1 ? '' : 's'}
              </p>
              <div className={styles.sortContainer}>
                <button
                  onClick={this._onFilterElementClick}
                  className={styles.iconSort}
                >
                  <img src={iconFilter} alt="filter" className={styles.iconFilter} />
                </button>
                { this.state.isFilterOpen &&
                <FiltersMobile
                  className={styles.filters}
                  callbackCloseFilters={this._onFilterElementClick}
                />
                }
                <SortSelect />
              </div>
            </div>
            <div className={styles.productContainer}>
              {
                SearchStore.filteredProducts.map(prod => (
                  <ProductCard
                    className={styles.productCard}
                    key={prod.id}
                    product={prod}
                  />
                ))
              }
            </div>
          </div>
        }
        {
          !!SearchStore.filteredProducts &&
          SearchStore.filteredProducts.length === 0 &&
          <p className={styles.message}>
            No hay resultados de búsqueda para mostrar. Verifica tu
            búsqueda o intenta con términos más generales.
          </p>
        }
      </div>
    );
  }
}


ProductMobileList.propTypes = IPropTypes;
ProductMobileList.defaultProps = defaultProps;


const ProductMobileListWrapped = observer(ProductMobileList);

export { ProductMobileListWrapped as ProductMobileList };



// WEBPACK FOOTER //
// ./src/pages/search/product-mobile-list/ProductMobileList.jsx